import { render, staticRenderFns } from "./FeatureSetup.vue?vue&type=template&id=6779360a&scoped=true&"
import script from "./FeatureSetup.vue?vue&type=script&lang=js&"
export * from "./FeatureSetup.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSetup.vue?vue&type=style&index=0&id=6779360a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779360a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6779360a')) {
      api.createRecord('6779360a', component.options)
    } else {
      api.reload('6779360a', component.options)
    }
    module.hot.accept("./FeatureSetup.vue?vue&type=template&id=6779360a&scoped=true&", function () {
      api.rerender('6779360a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/FeatureSetup.vue"
export default component.exports